import React from "react";
import DOMPurify from "dompurify";

/**
 * Options for rich text produced by Remirror WysiwygEditor (preset-wysiwyg,
 * TableExtension, iframe embeds). DOMPurify’s defaults already keep typical
 * formatting nodes (headings, lists, tables, links, emphasis, code blocks, SVG…);
 * we only extend the allow-list where needed so legitimate markup is not dropped.
 */
const SAFE_HTML_PURIFY_CONFIG = {
  ADD_TAGS: ["iframe"],
  ADD_ATTR: [
    "allow",
    "allowfullscreen",
    "frameborder",
    "referrerpolicy",
    "sandbox",
    "class",
    "data-missing-variable",
    "title",
  ],
};

/**
 * Renders HTML after sanitizing with DOMPurify (XSS mitigation).
 * @param {string} html - HTML string to render
 * @param {string} className - Additional CSS classes
 * @param {object} ...props - Other div props
 */
export default function SafeHtml({ html, className = "", ...props }) {
  const sanitized = DOMPurify.sanitize(html ?? "", SAFE_HTML_PURIFY_CONFIG);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: sanitized }}
      className={className}
      {...props}
    />
  );
}
